const API_SUBSCRIBE_URL = '/api/webinars/subscribe';
const API_SUBSCRIBE_REGISTERED_URL = '/api/webinars/subscribe-registered';

const buildEndpoint = (showPersonalDetailsFields, slug, culture) => {
	if (!slug || !culture) {
		throw new Error('Missing webinar slug or culture.');
	}

	const safeSlug = encodeURIComponent(slug);
	const safeCulture = encodeURIComponent(culture);

	if (showPersonalDetailsFields) {
		return `${API_SUBSCRIBE_URL}/${safeSlug}/${safeCulture}`;
	}

	return `${API_SUBSCRIBE_REGISTERED_URL}/${safeSlug}/${safeCulture}`;
};

const parseJson = async (response) => {
	try {
		return await response.json();
	} catch {
		return null;
	}
};

const subscribeToWebinar = async (showPersonalDetailsFields, { slug, culture, email, firstName, lastName }) => {
	const endpoint = buildEndpoint(showPersonalDetailsFields, slug, culture);
	const payload = {
		email,
		firstName,
		lastName,
	};

	const response = await fetch(endpoint, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'X-Requested-With': 'XMLHttpRequest',
		},
		body: JSON.stringify(payload),
	});

	const body = await parseJson(response);

	if (!response.ok) {
		const error = new Error(`Webinar subscription failed with status ${response.status}.`);
		error.response = response;
		error.payload = body;

		throw error;
	}

	return body ?? {};
};

export { subscribeToWebinar };
